import { render, staticRenderFns } from "./AuthCallback.vue?vue&type=template&id=afdcd28e&scoped=true&"
import script from "./AuthCallback.vue?vue&type=script&lang=js&"
export * from "./AuthCallback.vue?vue&type=script&lang=js&"
import style0 from "./AuthCallback.vue?vue&type=style&index=0&id=afdcd28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdcd28e",
  null
  
)

export default component.exports